var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.dashboardData && _vm.dashboardData !== null
      ? _c(
          "div",
          { key: _vm.refreshKey },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("routerTitles.Dashboard")))]),
            _vm._v(" "),
            _c("el-card", { staticClass: "mb-10" }, [
              _c("div", { staticClass: "row1" }, [
                _c("div", { staticClass: "disp-flex" }, [
                  _c("div", { key: _vm.refreshKey, staticClass: "pr-5" }, [
                    _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            size: "mini",
                            type: "daterange",
                            align: "right",
                            "unlink-panels": "",
                            "range-separator": "-",
                            "start-placeholder": _vm.$t("startDate"),
                            "end-placeholder": _vm.$t("endDate"),
                            "picker-options": _vm.pickerOptions,
                            format: "dd-MM-yyyy"
                          },
                          on: { change: _vm.handleDateRangeChange },
                          model: {
                            value: _vm.dateRange,
                            callback: function($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "mb-10", attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c("el-card", { staticStyle: { height: "180px" } }, [
                      _c("h3", { staticClass: "mb-10" }, [
                        _vm._v(_vm._s(_vm.$tc("documents", 777)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row2" }, [
                        _c("div", { staticClass: "disp-flex" }, [
                          _c(
                            "div",
                            { staticClass: "pt-15 pb-15 b-r-blue pl-10 pr-10" },
                            [
                              _c("div", { staticClass: "mb-5" }, [
                                _c("b", { staticClass: "fs-18" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("formatBigNumber")(
                                          _vm.dashboardData.dashboard_totals[0]
                                            .count_invoiced
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(_vm._s(_vm.$t("totalInvoiced")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("risoltoNumberFormatter")(
                                        _vm.dashboardData.dashboard_totals[0]
                                          .total_invoiced
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-15 pb-15 b-r-blue pl-10 pr-10" },
                            [
                              _c("div", { staticClass: "mb-5" }, [
                                _c("b", { staticClass: "fs-18" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("formatBigNumber")(
                                          _vm.dashboardData.dashboard_totals[0]
                                            .count_invoiced_paid
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(_vm._s(_vm.$t("totalPaid")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("risoltoNumberFormatter")(
                                        _vm.dashboardData.dashboard_totals[0]
                                          .total_invoiced_paid
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-15 pb-15 b-r-blue pl-10 pr-10" },
                            [
                              _c("div", { staticClass: "mb-5" }, [
                                _c("b", { staticClass: "fs-18" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("formatBigNumber")(
                                          _vm.dashboardData.dashboard_totals[0]
                                            .count_invoiced_unpaid
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(_vm._s(_vm.$t("totalUnpaid")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("risoltoNumberFormatter")(
                                        _vm.dashboardData.dashboard_totals[0]
                                          .total_invoiced_unpaid
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-15 pb-15 b-r-blue pl-10 pr-10" },
                            [
                              _c("div", { staticClass: "mb-5" }, [
                                _c("b", { staticClass: "fs-18" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(_vm._s(_vm.$t("totalOpenBalance")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("risoltoNumberFormatter")(
                                        _vm.dashboardData.dashboard_totals[0]
                                          .open_balance
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-15 pb-15 b-r-blue pl-10 pr-10" },
                            [
                              _c("div", { staticClass: "mb-5" }, [
                                _c("b", { staticClass: "fs-18" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("totalOpenBalanceNonOverdue"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("risoltoNumberFormatter")(
                                        _vm.dashboardData.dashboard_totals[0]
                                          .open_balance_non_overdue
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-15 pb-15 pl-10" }, [
                            _c("div", { staticClass: "mb-5" }, [
                              _c("b", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "smaller" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("totalOpenBalanceOverdue"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-18" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("risoltoNumberFormatter")(
                                      _vm.dashboardData.dashboard_totals[0]
                                        .open_balance_overdue
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "mb-10", attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      { staticStyle: { height: "180px" } },
                      [
                        _c("h3", { staticClass: "mb-10" }, [
                          _vm._v(_vm._s(_vm.$tc("recipient", 777)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-alert",
                          {
                            attrs: {
                              title: `${_vm.$t("totalRecipients")}`,
                              type: "success",
                              "show-icon": "",
                              closable: false
                            }
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "25px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatBigNumber")(
                                        _vm.dashboardData.total_recipients
                                          .aggregate.count
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("el-card", { staticStyle: { height: "180px" } }, [
                      _c("h3", { staticClass: "mb-10" }, [
                        _vm._v(_vm._s(_vm.$tc("action", 777)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex mb-10" }, [
                        _c("div", { staticStyle: { width: "25%" } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { width: "25%", color: "#ff4949" } },
                          [_c("strong", [_vm._v(_vm._s(_vm.$t("open")))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { width: "25%", color: "#13ce66" } },
                          [_c("strong", [_vm._v(" " + _vm._s(_vm.$t("done")))])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex mb-5" }, [
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("svg-icon", {
                              staticStyle: { color: "#4EB0B9" },
                              attrs: { "icon-class": "at-solid" }
                            }),
                            _vm._v(" \n\t\t\t\t\t\t\t"),
                            _c("span", { staticStyle: { color: "#4EB0B9" } }, [
                              _vm._v("Email")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_email_open
                                .aggregate.count
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_email_done
                                .aggregate.count
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex mb-5" }, [
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("svg-icon", {
                              staticStyle: { color: "#4EB0B9" },
                              attrs: { "icon-class": "envelope-solid" }
                            }),
                            _vm._v("\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"),
                            _c("span", { staticStyle: { color: "#4EB0B9" } }, [
                              _vm._v(_vm._s(_vm.$t("postal")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_mail_open
                                .aggregate.count
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_mail_done
                                .aggregate.count
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex mb-5" }, [
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("svg-icon", {
                              staticStyle: { color: "#4EB0B9" },
                              attrs: { "icon-class": "phone-solid" }
                            }),
                            _vm._v(" \n\t\t\t\t\t\t\t"),
                            _c("span", { staticStyle: { color: "#4EB0B9" } }, [
                              _vm._v(_vm._s(_vm.$t("phone")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_phone_open
                                .aggregate.count
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_phone_done
                                .aggregate.count
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex" }, [
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("svg-icon", {
                              staticStyle: { color: "#4EB0B9" },
                              attrs: { "icon-class": "sms-solid" }
                            }),
                            _vm._v(" \n\t\t\t\t\t\t\t"),
                            _c("span", { staticStyle: { color: "#4EB0B9" } }, [
                              _vm._v("SMS")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_sms_open.aggregate
                                .count
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.dashboardData.total_actions_sms_done.aggregate
                                .count
                            )
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-row", [
              _c("div", { staticClass: "mb-500" }, [
                _c(
                  "section",
                  [
                    _c(
                      "el-card",
                      [
                        _c("h3", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(_vm.$t("Charts.aging_balance")))
                        ]),
                        _vm._v(" "),
                        _c("aging-balance", {
                          attrs: { "date-range": _vm.dateRange }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      : _vm.dashboardData === null
      ? _c("div", [_vm._v("\n\t\tNo data available\n\t")])
      : _c(
          "div",
          { staticClass: "text-center" },
          [
            _c("div", { staticStyle: { height: "100px" } }),
            _vm._v(" "),
            _c("loader", { staticClass: "mt-50 mb-50" }),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "100px" } })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }